import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'string',
    standalone: true,
})
export class StringPipe implements PipeTransform {
    transform(value: unknown, radix = 10): string {
        if (value == null || value === undefined) {
            return '';
        }

        if (typeof value === 'number') {
            return value.toString(radix);
        }

        if (typeof value === 'string') {
            return value;
        }

        if (typeof value === 'object') {
            if (
                Object.prototype.hasOwnProperty.call(value, 'toString') &&
                typeof value.toString === 'function'
            ) {
                // We safely handled object toString here.
                // eslint-disable-next-line @typescript-eslint/no-base-to-string
                return value.toString();
            }

            try {
                return JSON.stringify(value);
            } catch {
                return '[object Object]';
            }
        }

        if (typeof value.toString === 'function') {
            // We safely handled object toString above.
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            return value.toString();
        }

        // We safely handled object toString above.
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        return String(value);
    }
}
